import { Box, Divider, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../../../constants/LinkConstants";
import styles from "./AutomotiveBestPracticesContent.module.scss";
import { getBestPracticesData } from "./BestPractices/Data/automotive-best-practices-data";
import SceneDescriptionContent from "./BestPractices/SceneDescriptionContent/SceneDescriptionContent";
import AutomotiveBestPracticeSection from "./BestPractices/Section/AutomotiveBestPracticeSection";

type Props = {
	hideHeader?: boolean;
	onClose: () => void;
};

const AutomotiveBestPracticesContent = ({ hideHeader, onClose }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.automotive.bestPractices.content" });
	const data = getBestPracticesData(t);
	const { t: tPopup } = useTranslation("translation", {
		keyPrefix: "playground.automotive.models.popups.bestPractices",
	});

	return (
		<Box className={styles.root}>
			{!hideHeader && <Typography className={styles.header}>{t("header")}</Typography>}
			<AutomotiveBestPracticeSection
				id={tPopup("taps.overview.id")}
				description={t("overviewSection.desc")}
				className={styles.overviewSection}
			/>
			<Divider className={styles.sectionDivider} />
			<AutomotiveBestPracticeSection
				id={tPopup("taps.prepareYourImage.id")}
				title={t("prepareYourImageSection.title")}
				useCases={data.prepareYourImage}
				className={styles.prepareCarImages}
			/>
			<Divider className={styles.sectionDivider} />
			<AutomotiveBestPracticeSection
				id={tPopup("taps.sceneDescription.id")}
				title={t("sceneDescriptionSection.title")}
				description={t("sceneDescriptionSection.desc")}
				customContent={<SceneDescriptionContent />}
			/>
			<Divider className={styles.sectionDivider} />

			<AutomotiveBestPracticeSection
				id={tPopup("taps.addEnhancements.id")}
				title={t("addEnhancementsSection.title")}
				useCases={data.addEnhancements}
			/>
			<Divider className={styles.sectionDivider} />
			<Box className={styles.footer}>
				<Typography className={styles.footerTitle}>{t("footer.title")}</Typography>
				<Typography className={styles.footerSubTitle}>{t("footer.subTitle")}</Typography>
				<Box className={styles.actions}>
					<BriaButton buttonType="secondaryMedium" onClick={onClose}>
						{t("footer.backToEditor")}
					</BriaButton>
					<BriaButton
						buttonType="primaryMedium"
						onClick={() => window.open(LinkConstants.CONTACT_US_FORM_LINK)}
					>
						{t("footer.contactOurTeam")}
					</BriaButton>
				</Box>
			</Box>
		</Box>
	);
};

export default observer(AutomotiveBestPracticesContent);
